import { uptime } from 'process';
import { IS_BROWSER_ENVIRONMENT } from './isBrowserEnvironment';
/**
 * Get the elapsed time since process start, considering Node.js and Browser environments.
 *
 * @returns The elapsed time since start in milliseconds
 */
export function getElapsedTime() {
    return IS_BROWSER_ENVIRONMENT ? performance.now() : uptime() * 1000;
}
//# sourceMappingURL=getCurrentTime.js.map